<template>
    <div class="pa-4">
        <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-1"
            :search="search"   
            >
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>Outlets</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical />
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details />
                    <v-spacer />
                    <v-btn color="primary" dark class="mb-2" small @click="createOutlet" v-if="$store.state.currentPagePriv.create">
                        <v-icon small>mdi-plus</v-icon>
                        Add Outlet
                    </v-btn>
                    <v-dialog v-model="dialogDelete" max-width="500px">
                        <v-card>
                            <v-card-title class="text-h5">Konfirmasi</v-card-title>
                            <v-card-text>Anda akan menghapus outlet ini ?</v-card-text>
                            <v-card-actions>
                                <v-spacer />
                                <v-btn color="grey" text @click="dialogDelete = false">Cancel</v-btn>
                                <v-btn color="red" text @click="deleteItemConfirm">Delete</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:[`item.delivery`]="{ item }">
             {{ getScheduleDays(item.delivery_schedules) }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon small class="mr-2" @click="viewDetail(item)">
                    mdi-eye
                </v-icon>
                <v-icon small class="mr-2" @click="editOutlet(item)" v-if="$store.state.currentPagePriv.update">
                    mdi-pencil
                </v-icon>
                <v-icon small @click="deleteItem(item)" v-if="$store.state.currentPagePriv.delete">
                    mdi-delete
                </v-icon>
            </template>
            <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">
                    Reset
                </v-btn>
            </template>
        </v-data-table>
    </div>
</template>

<script>
    export default {
        data: () => ({
            dialog: false,
            dialogDelete: false,
            headers: [
                { text: 'Code', value: 'code' },
                { text: 'Outlet', value: 'name' },
                { text: 'Delivery Schedule', value: 'delivery', sortable: false },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            items: [],
            editedIndex: -1,
            editedItem: {},
            defaultItem: {},
            search: '',
            delivery_schedules: [
                { key: 1, value: 'Minggu' },
                { key: 2, value: 'Senin' },
                { key: 3, value: 'Selasa' },
                { key: 4, value: 'Rabu' },
                { key: 5, value: 'Kamis' },
                { key: 6, value: 'Jumat' },
                { key: 7, value: 'Sabtu' },
            ],
        }),

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? 'New Outlet' : 'Edit Outlet'
            },
        },

        watch: {
            dialog(val) {
                val || this.close()
            },
        },

        created() {
            this.initialize()
        },

        methods: {
            getScheduleDays(data) {
                return this.delivery_schedules
                    .filter(schedule => data.includes(schedule.key))
                    .map(schedule => schedule.value)
                    .join(', ')
            },
            async initialize() {
                let response = await this.$store.dispatch('outlet/getObjs')
                console.log(response)
                if (response.data.status == 'success') {
                    this.items = response.data.data
                }
            },
            async createOutlet() {
                this.$router.push('/outlet/create/new');
            },
            viewDetail(item) {
                this.$router.push(`/outlet/detail/${item.code}`)
            },
            async editOutlet(item) {
                this.$router.push(`/outlet/create/${item.code}`)
            },
            deleteItem(item) {
                this.editedIndex = this.items.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialogDelete = true
            },
            async deleteItemConfirm() {
                try {
                    const result = (await this.$store.dispatch('outlet/deleteObj', this.editedItem.code))
                    console.log(result)
                    if (result.data.status == 'success') {
                        this.items.splice(this.editedIndex, 1);
                        this.$store.commit('setSnackbar', {saveSuccess: true, successMessage: 'Outlet berhasil dihapus'});
                    }
                } catch (error) {
                    console.log(error);
                    this.$store.commit('setSnackbar', {saveError: true, errorMessage: error.response.data.message});
                } finally {
                    this.dialogDelete = false
                }
            }
        }
    }
</script>